import createObjectVersionManager from 'powtoon-commons/json-versioning'
import {versions} from './powtoonContentVersions'

export const updatePowtoonContent = createObjectVersionManager({
  getUpgradeFunction: version => version.updatePowtoonContent,
  versions
})